import React from 'react';
import ReactHTMLParser from 'react-html-parser';
import SvgInline from '@latitude/svg-inline';

const hasRichTextContent = richText =>
  richText?.nodeType === 'document' && richText?.content?.length > 0;

const stripMarkedParagraph = value =>
  typeof value === 'string'
    ? value.replace(/^<p>/, '').replace(/<\/p>\n?$/, '')
    : value;

const getFeatureText = card => {
  if (hasRichTextContent(card?.richText)) {
    return {
      richText: card.richText
    };
  }

  if (card?.text) {
    return {
      paragraphText: ReactHTMLParser(stripMarkedParagraph(card.text))
    };
  }

  return {};
};

const mapFeatureCard = card => ({
  icon: card.icon ? <SvgInline name={card.icon} /> : undefined,
  headingText: card.title,
  title: card.title,
  ...getFeatureText(card)
});

export const getFeatureGridV1DataFromContentful = featureSlider => {
  const featureCards = featureSlider?.featureCards?.filter(
    card => card?.title && (card?.richText || card?.text)
  );

  if (!featureCards?.length) return null;

  const features = featureCards.slice(0, 4).map(mapFeatureCard);
  const moreFeatures = featureCards.slice(4).map(mapFeatureCard);

  return {
    features,
    moreFeatures: moreFeatures.length ? moreFeatures : undefined
  };
};
